import { bindable } from 'aurelia-framework';

class JobsList {
  @bindable loading = false;
  @bindable jobs = [];
  @bindable onViewJobAccount = () => {};
  @bindable onViewJob = () => {};
  jobsList = [];
  _jobsFormatted = [];
  jobsChanged() {
    this._jobsFormatted = this.jobs.map((job) => Object.assign({}, job, {
      searchable: [
        `${job.account.id}`,
        job.account.name.toLowerCase(),
        job.title.toLowerCase(),
        job.type.toLowerCase(),
      ],
    }));

    this._search();
  }
  onSearchTextChange(text) {
    this._search(text);
  }
  _search(text = '') {
    const query = text.trim().toLowerCase();
    if (text) {
      this.jobsList = this._jobsFormatted.filter((job) => job.searchable.some((property) => (
        property.includes(query)
      )));
    } else {
      this.jobsList = this._jobsFormatted.slice();
    }
  }
}

export { JobsList };
